import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL;

/**
 * ส่ง log ไป backend เพื่อหาสาเหตุที่ QR บนหน้า /donate ไม่แสดงผล
 * ดู docs/donate-qr-image-bug.md
 *
 * ห้ามส่ง personal_id / mobile_number / amount — เป็นข้อมูลส่วนบุคคลของผู้บริจาค
 * การ log ต้องไม่ทำให้ผู้ใช้เห็น error ซ้อน จึงกลืนความล้มเหลวของตัวมันเองทิ้ง
 */
export function useClientLog() {
  const reportClientLog = (event, details = {}) => {
    try {
      axios
        .post(
          `${API_BASE_URL}/client-log`,
          {
            event,
            route: window.location.pathname,
            ...details,
          },
          { timeout: 10000 },
        )
        .catch(() => {});
    } catch {
      // เงียบโดยตั้งใจ
    }
  };

  /** ดึงข้อมูลจาก error ของ axios ให้อยู่ในรูปที่ log ได้ ไม่มีข้อมูลผู้บริจาคติดไปด้วย */
  const describeAxiosError = (error) => ({
    errorCode: error?.code,
    errorMessage: error?.message,
    httpStatus: error?.response?.status,
  });

  /** บอกได้ว่า src เป็น PNG จริงไหม โดยไม่ log ทั้งก้อน */
  const describeImageSrc = (src) => ({
    srcLength: typeof src === 'string' ? src.length : 0,
    srcPrefix: typeof src === 'string' ? src.slice(0, 30) : '',
  });

  return { reportClientLog, describeAxiosError, describeImageSrc };
}
